import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, CircularProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import useWarehouseIM from 'hooks/useWarehouseIM';
import { IWareHouseList } from 'interfaces/imWarehouse.interface';

interface Props {
  handleCloseModal(): void;
  handleOnSubmit(data: IWareHouseList): Promise<boolean>;
  getAllWarehouses(): void;
  warehouseId: string;
}

export default function IMWarehouseForm({ handleCloseModal, handleOnSubmit, warehouseId, getAllWarehouses }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const { showNotistack } = useCustomSnackbar();
  const { handleSubmit, register, errors, reset } = useForm<IWareHouseList>();
  const { getWarehouseById } = useWarehouseIM();

  const onSubmit = (data: IWareHouseList) => {
    setIsLoading(true);

    if (warehouseId) {
      data.id = warehouseId;
    }

    handleOnSubmit(data)
      .then((response: boolean) => {
        if (response === true) {
          showNotistack({ message: 'La bodega se guardó correctamente' });
          getAllWarehouses();
          handleCloseModal();
        } else {
          showNotistack({ message: 'Ocurrió un error' });
        }
      })
      .catch((err: any) => {
        console.log(err.reponse?.data);
        showNotistack({ message: 'Ocurrió un error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (warehouseId) {
      setIsLoading(true);
      getWarehouseById(warehouseId)
        .then((resultWarehouse: IWareHouseList) => {
          reset(resultWarehouse);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [warehouseId]);

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      <Grid container direction="row" spacing={2} justify="center">
        <Grid item xs={12} sm={12} md={12}>
          <Grid container direction="row" justify="center" spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                required
                variant="outlined"
                autoFocus
                margin="normal"
                fullWidth
                name="name"
                label="Bodega"
                autoComplete="name"
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido'
                })}
                error={errors.name ? true : false}
                helperText={errors.name && errors.name.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="phone"
                label="Teléfono"
                autoComplete="phone"
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido',
                  pattern: {
                    value: /^[0-9\b]+$/,
                    message: 'Teléfono invalido'
                  }
                })}
                error={errors.phone ? true : false}
                helperText={errors.phone && errors.phone.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          <TextField
            required
            variant="outlined"
            margin="normal"
            fullWidth
            label="Dirección"
            name="address"
            autoComplete="address"
            disabled={isLoading}
            inputRef={register<HTMLInputElement>({
              required: 'Este campo es requerido'
            })}
            error={errors.address ? true : false}
            helperText={errors.address && errors.address.message}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email de contacto"
            name="email"
            autoComplete="email"
            disabled={isLoading}
            inputRef={register<HTMLInputElement>({
              required: 'Este campo es requerido',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Email invalido'
              }
            })}
            error={errors.email ? true : false}
            helperText={errors.email && errors.email.message}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Button type="submit" variant="contained" color="primary" disabled={isLoading} style={{ marginTop: 20 }}>
          {isLoading ? <CircularProgress size={24} /> : ''} Guardar
        </Button>
        <Button
          variant="contained"
          color="default"
          disabled={isLoading}
          style={{ marginTop: 20, marginLeft: 20 }}
          onClick={handleCloseModal}
        >
          {isLoading ? <CircularProgress size={24} /> : ''} Cancelar
        </Button>
      </Grid>
    </form>
  );
}
